import actionFe from 'utils/mw/actionFe.util';

const feDeleteLocalTimeOffCategory = actionFe('feDeleteLocalTimeOffCategory');

// noinspection JSUnusedGlobalSymbols
export default feDeleteLocalTimeOffCategory;
